/** R25-6: one used machine the shop offers for an article — a single piece with its own fixed price. */
export interface UsedUnitOffer {
    id: string;
    conditionLabel: string | null;
    cups: number | null;
    months: number | null;
    priceNet: number;
    priceGross: number;
    note: string | null;
}

export const usedUnitOfferFromJson = (json: any): UsedUnitOffer => ({
    id: json.id,
    conditionLabel: json.conditionLabel ?? null,
    cups: json.cups ?? null,
    months: json.months ?? null,
    priceNet: Number(json.priceNet ?? 0),
    priceGross: Number(json.priceGross ?? json.priceNet ?? 0),
    note: json.note ?? null,
});

/** The shop shows gross unless the visitor switched the price display to net. */
export function usedUnitDisplayPrice(unit: UsedUnitOffer, priceType: string | null | undefined): number {
    return priceType === 'net' ? unit.priceNet : unit.priceGross;
}

/** German thousands grouping without relying on the runtime's ICU data. */
export const formatThousands = (value: number): string =>
    String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

/** "~12.000 Cafés · 14 Monate" — the usage facts of a piece, in display order. */
export function usedUnitFacts(
    unit: UsedUnitOffer,
    t: (key: string, options?: Record<string, unknown>) => string
): string[] {
    const facts: string[] = [];
    if (unit.cups != null) facts.push(t('shop.used.cups', { count: formatThousands(unit.cups) }));
    if (unit.months != null) facts.push(t('shop.used.months', { count: unit.months }));
    return facts;
}
